app.controller("SidenavController", [
    "$scope", "$interval", "$state", "Socket", "AuthService", "usSpinnerService", "NotificationService", "PollService", "AgreementService", "$uibModal", "$rootScope", "RemindersService",
    function ($scope, $interval, $state, Socket, AuthService, usSpinnerService, NotificationService, PollService, AgreementService, $uibModal, $rootScope, RemindersService) {
        this.navCollapsed = true;
        this.darkBackground = false;
        var that = this;
        $scope.unread = -1;
        $scope.unAnswered = -1;
        $scope.unsnoozed = -1;
        $scope.sum = -1;
        $scope.total = -1;
        $scope.socket = new Socket();
        $scope.user = null;
        $scope.showUserData = false;

        AuthService.getPass().then(function (pass) {
            if($state.current.name.slice(0,8) === 'employee') {
                $scope.showUserData = true;
            }
            $scope.user = pass.data;
        });

        AuthService.checkPasswordChange().then(function (data) {
            if(!data.length) {
                $uibModal.open({
                    controller: "ChangePassWinController",
                    templateUrl: _pb + 'parameters/changePasswordWindow.html',
                    size: "md",
                    backdrop: 'static',
                    resolve: {
                        params: function () {
                            return {type: 'update'};
                        }
                    }
                }).result
                    .then(function (result) {

                    }, function () {
                    });
            }
        })

        $scope.socket.on('notification', function () {
            $scope.notificationCount();
        });

        $scope.socket.on('poll', function () {
            $scope.pollCount();
        });

        this.logout = function () {
            AuthService.logout().then(function () {
                $state.go("login");
            });
        };

        $scope.$on('us-spinner:spin', function (event, key) {
            if (key === "root") {
                that.darkBackground = true;
            }
        });

        $scope.$on('us-spinner:stop', function (event, key) {
            if (key === "root") {
                that.darkBackground = false;
            }
        });

        this.start = function () {
            usSpinnerService.spin("root");
        };

        this.stop = function () {
            usSpinnerService.stop("root");
        };

        $scope.playAudio = function () {
            var audio = new Audio('audio/notification.mp3');
            audio.play();
        };

        $scope.notificationCount = function () {
            NotificationService.unread().then(function (data) {
                $scope.unread = data.unread;
                $scope.total = data.total;

                if($scope.unread > 0) {
                    NotificationService.received({}).then(function (data) {
                        var notifications = data.docs;
                        var unreadNotifications = _.filter(notifications, {state: 'unread'});
                        var priorityNotification = _.find(unreadNotifications, function (record) {
                            return record.notification.priority > 3;
                        });

                        if (priorityNotification) {
                            $scope.openNotification(priorityNotification);
                        }

                        usSpinnerService.stop("root");
                    });
                }

                if ($scope.unread >= 0 && $scope.total >= 0) {
                    if ($scope.total < data.total && $scope.unread < data.unread) {
                        setTimeout(function () {
                            $scope.playAudio()
                        }, 1000);
                    }
                    $rootScope.$broadcast('loadPage', {});
                }

                if($scope.unread >= 0 && $scope.unAnswered >= 0) $scope.sum = $scope.unread + $scope.unAnswered;
                else if($scope.unread > 0) $scope.sum = $scope.unread ;
                else if($scope.unAnswered > 0) $scope.sum = $scope.unAnswered;

                if($scope.unsnoozed > 0) $scope.sum += $scope.unsnoozed;
            })
        };

        $scope.pollCount = function () {
            PollService.unread().then(function (data) {
                if ($scope.unAnswered >= 0 && $scope.total >= 0) {
                    if ($scope.total < data.total && $scope.unAnswered < data.unread) {
                        setTimeout(function () {
                            $scope.playAudio()
                        }, 1000);
                    }
                    $rootScope.$broadcast('loadPage', {});
                }
                $scope.unAnswered = data.unread;
                $scope.total = data.total;

                if($scope.unread >= 0 && $scope.unAnswered >= 0) $scope.sum = $scope.unread + $scope.unAnswered;
                else if($scope.unread > 0) $scope.sum = $scope.unread ;
                else if($scope.unAnswered > 0) $scope.sum = $scope.unAnswered;

                if($scope.unsnoozed > 0) $scope.sum += $scope.unsnoozed;
            })
        };

        $scope.reminderCount = function () {
            RemindersService.list({current: true}).then(function(data){
                $scope.unsnoozed = data.total;

                if($scope.unread >= 0 && $scope.unAnswered >= 0) $scope.sum = $scope.unread + $scope.unAnswered;
                else if($scope.unread > 0) $scope.sum = $scope.unread ;
                else if($scope.unAnswered > 0) $scope.sum = $scope.unAnswered;

                if($scope.unsnoozed > 0) $scope.sum += $scope.unsnoozed;
            });
        };

        $scope.agreementCount = function () {
            AgreementService.unread({current: true}).then(function(data){
               if(data && data[0]) {
                   $scope.openAgreement(data[0])
               }
            });
        }

        $scope.mark = function (poll) {
            PollService.mark({
                poll: poll,
                state: 'read'
            });
        };

        $scope.markNotification = function (notification) {
            NotificationService.mark({
                notification: notification,
                state: 'read'
            }).then(function () {
                $rootScope.$broadcast('notificationCount', {});
            });
        };

        $scope.openPoll = function () {
            PollService.getLast().then(function (data) {
                if(data) $scope.open(data)
            })
        };

        $scope.open = function (item) {
            $uibModal.open({
                controller: "PollsWindowController",
                templateUrl: _pb + 'admin/polls/poll-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {info: item, poll: item.poll};
                    }
                }
            }).result
                .then(function (result) {
                    if (!result && item.state === 'unread') $scope.mark(item._id);
                    $scope.openPoll()
                }, function () {
                    if (item.state === 'unread') $scope.mark(item._id);
                    $scope.openPoll()
                });
        };

        $scope.openNotification = function (item) {
            $uibModal.open({
                controller: "NotificationsWindowController",
                templateUrl: _pb + 'notifications/notification-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {notification: item.notification};
                    }
                }
            }).result
                .then(function () {
                    $scope.markNotification(item._id);
                }, function () {
                    if (item.state === 'unread') {
                        $scope.markNotification(item._id);
                    }
                });
        };

        $scope.openAgreement = function (item) {
            $uibModal.open({
                controller: "NotificationsWindowController",
                templateUrl: _pb + 'notifications/notification-window.html',
                size: "md",
                backdrop  : 'static',
                keyboard  : false,
                resolve: {
                    params: function () {
                        return {notification: item.agreement, _id: item._id};
                    }
                }
            }).result
                .then(function () {
                    $scope.markNotification(item._id);
                }, function () {
                    if (item.state === 'unread') {
                        $scope.markNotification(item._id);
                    }
                });
        };

        $scope.$on('notificationCount', function () {
            $scope.notificationCount()
        });

        $scope.$on('pollCount', function () {
            $scope.pollCount()
        });

        $scope.$on('reminderCount', function () {
            $scope.reminderCount()
        });

        $scope.$on('agreementCount', function () {
            $scope.agreementCount()
        });

        $scope.notificationCount();
        $scope.pollCount();
        $scope.reminderCount();
        $scope.agreementCount();
        $scope.openPoll();

        $rootScope.hasRight = function (right) {
            return AuthService.hasRight(right);
        };

        $rootScope.hasRole = function (role) {
            return AuthService.hasRole(role);
        };
    }
]);
